import React from 'react';
import {
    Dialog,
    DialogContent,
    IconButton,
    Typography,
    Box,
    Button,
    styled,
    useMediaQuery,
    useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCart } from '../Context/CardContext';

interface SubtrendDialogProps {
    open: boolean;
    onClose: () => void;
    subtrend: {
        id: string;
        title: string;
        text: string;
        image: string;
    };
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        maxWidth: '800px',
        width: '90%',
        borderRadius: '12px',
        overflow: 'hidden'
    }
}));

const DialogHeader = styled(Box)(({ theme }) => ({
    position: 'relative',
    height: '400px',
    width: '100%',
    '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'top'
    },
    [theme.breakpoints.down('sm')]: {
        height: '250px',
    }
}));

const CloseButton = styled(IconButton)({
    position: 'absolute',
    top: '16px',
    right: '16px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 1)'
    }
});

const ContentContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
    }
}));

const SubtrendDialog: React.FC<SubtrendDialogProps> = ({ open, onClose, subtrend }) => {
    const { addItem } = useCart();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleAddToCart = () => {
        addItem({
            id: subtrend.id,
            title: subtrend.title,
            image: subtrend.image,
            type: 'trend'
        });
        onClose();
    };

    return (
        <StyledDialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            fullScreen={isSmallScreen}
        >
            <DialogHeader>
                <img src={subtrend.image} alt={subtrend.title} />
                <CloseButton onClick={onClose}>
                    <CloseIcon />
                </CloseButton>
            </DialogHeader>
            <DialogContent>
                <ContentContainer>
                    <Typography
                        variant={isSmallScreen ? "h5" : "h4"}
                        component="h2"
                        gutterBottom
                    >
                        {subtrend.title}
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
                        {subtrend.text}
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: isSmallScreen ? 'center' : 'flex-end',
                        mt: isSmallScreen ? 2 : 4
                    }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleAddToCart}
                            fullWidth={isSmallScreen}
                            sx={{
                                borderRadius: '24px',
                                padding: isSmallScreen ? '8px 16px' : '8px 32px'
                            }}
                        >
                            In den Warenkorb
                        </Button>
                    </Box>
                </ContentContainer>
            </DialogContent>
        </StyledDialog>
    );
};

export default SubtrendDialog;